import { gql } from "graphql-request";

/** Shared `me` selection for session / onboarding gating (keep in sync with {@link AuthProvider}). */
export const ME_DOCUMENT = gql`
  query Me {
    me {
      id
      org_id
      email
      name
      first_name
      last_name
      company
      jobtitle
      onboarding_completed
      signup_completed_at
      signup_conversion_pending
      capacity_status {
        state
        reason
        message
        onboarding_message
        global_gpu_available
      }
      chat_settings {
        globally_enabled
      }
      docs_settings {
        globally_enabled
      }
      billing_summary {
        billing_complete
        welcome_credit_amount_cents
      }
      extra_roles
      org_role
      email_is_consumer
      org {
        id
        kind
        name
      }
      orgs {
        id
        kind
        name
      }
    }
  }
`;

export type MeCapacityStatus = {
  state: string;
  reason: string | null;
  message: string;
  onboarding_message: string;
  global_gpu_available: boolean;
};

export type MeChatSettings = {
  globally_enabled: boolean;
};

export type MeDocsSettings = {
  globally_enabled: boolean;
};

export type MeBillingSummary = {
  billing_complete: boolean;
  welcome_credit_amount_cents: number;
};

export type MeQueryData = {
  me: {
    id: string;
    org_id: string | null;
    email: string;
    name: string | null;
    first_name: string | null;
    last_name: string | null;
    company: string | null;
    jobtitle: string | null;
    onboarding_completed: boolean;
    signup_completed_at: string | null;
    signup_conversion_pending: boolean;
    capacity_status: MeCapacityStatus;
    chat_settings: MeChatSettings;
    docs_settings: MeDocsSettings;
    billing_summary: MeBillingSummary;
    extra_roles: string[];
    org_role: string | null;
    email_is_consumer: boolean;
    org: { id: string; kind: string; name: string } | null;
    orgs: Array<{ id: string; kind: string; name: string }>;
  };
};
